enum Bingo60PrizeType {
  Jackpot = 'jackpot',
  Prize = 'prize'
}

function getPrizeTypeName(prizeType: Bingo60PrizeType): string {
  switch (prizeType) {
    case Bingo60PrizeType.Jackpot:
      return 'Jackpot';
    case Bingo60PrizeType.Prize:
      return 'Prize';
  }
}

function getPrizeTypeNameForLevel(prizeTypeLevel: number): string {
  switch (prizeTypeLevel) {
    case 1:
      return 'Orange';
    case 2:
      return 'Green';
    case 3:
      return 'Red';
    case 4:
      return 'Purple';
    case 5:
      return 'Blue';
  }
}

function getPrizeTypeStage(prizeType: Bingo60PrizeType): number {
  switch (prizeType) {
    case Bingo60PrizeType.Jackpot:
      return 2;
    case Bingo60PrizeType.Prize:
      return 1;
  }
}

export { Bingo60PrizeType, getPrizeTypeName, getPrizeTypeNameForLevel, getPrizeTypeStage };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/implementations/uk/bingo-60/_domain/models/prize-type.ts